<template>
    <div class="vip_box">
        <div :class="['vip_one_' + (index+1), defaultSelect&&index==0?'select':'']" class="vip_one" v-for="(item, index) in list" :key="index" @click="chooseItem(item)">
            <p class="vip_one_empty"></p>
            <p class="vip_one_name">{{item.name}}</p>
            <!-- <p class="vip_one_price" v-if="item.id == 1">免费</p> -->
            <p class="vip_one_price" v-if="item.id == 2">¥{{ item.price }}/月</p>
            <p class="vip_one_price" v-if="item.id == 3">¥{{ item.price }}/季</p>
            <p class="vip_one_price" v-if="item.id == 4">¥{{ item.price }}/年</p>
            <!-- <button class="vip_one_button" 
              :class="item.price == '0.00' ? 'cursor-auto' : 'cursor-pointer'"
              @click="buyVip(item)">
                {{item.price == '0.00' ? '已注册' :'购买'}}
            </button> -->
            <button class="vip_one_button" @click="buyVip(item)">
                购买
            </button>
            <div class="vip_one_tag">
                <ul class="vip_one_ul">
                    <li>
                        <img src="@/assets/icon_duigou.png" alt="">
                        {{item.desc1}}
                    </li>
                    <li v-if="item.desc2 && item.desc2.length > 1">
                        <img src="@/assets/icon_duigou.png" alt="">
                        {{ item.desc2 }}
                    </li>
                    <li v-if="item.desc3 && item.desc3.length > 1">
                        <img src="@/assets/icon_duigou.png" alt="">
                        {{ item.desc3 }}
                    </li>
                    <li v-if="item.desc4 && item.desc4.length > 1">
                        <img src="@/assets/icon_duigou.png" alt="">
                        {{ item.desc4 }}
                    </li>
                    <li v-if="item.desc5 && item.desc5.length > 1">
                        <img src="@/assets/icon_duigou.png" alt="">
                        {{ item.desc5 }}
                    </li>
                </ul>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list:[],
            defaultSelect:true
        }
    },
    props:['priceNum'],
    mounted() {
      this.vipRights()
    //   console.log(this.list);
    },
    methods:{
        vipRights() { //VIP权益
            let params = {
                token: window.localStorage.getItem('token'),
            }
            this.$api.vipEquity(params).then(res => {
                this.list = res.data
                console.log(res.data);
                this.$emit('selectVip', this.list[0])
            })
        },
        buyVip(item){
            if(item.price != 0.00){
                let params = {
                    token: window.localStorage.getItem('token'),
                    member_id: item.id
                }
                this.$api.buyVipPlace(params).then(res => {
                    // console.log(res)
                    window.location.href = res.data
                })
            }else{
                return
            }            
        },
        chooseItem(item){
            // console.log(item);
            this.defaultSelect = false
            this.$emit('selectVip', item )
        }
    }
}
</script>

<style lang='scss' scoped>
.vip_box {
    @apply flex max-sm:overflow-auto pb-2;
    .vip_one {
        flex-shrink: 0;
        @apply overflow-hidden w-[300px] h-[536px] max-sm:w-[198px] max-sm:h-[322px] rounded-[15px] bg-white mr-[20px] flex flex-col items-center border cursor-pointer;
        .vip_one_empty {
            @apply w-full h-[12px] max-sm:h-[8px] bg-[#24CCA7];
        }
        .vip_one_name {
            @apply mt-[28px] mb-[12px] text-[#333] text-base max-sm:mt-[12px] max-sm:mb-[8px] max-sm:text-[14px];
        }
        .vip_one_price {
            @apply mb-[30px] text-[#333] text-[40px] font-semibold max-sm:text-[24px] max-sm:mb-[20px];
        }
        .vip_one_button {
            @apply max-sm:hidden mb-[40px] w-[240px] h-[46px] rounded-[10px] bg-[#fff] text-[#24CCA7] text-[18px] border border-[#24CCA7] cursor-pointer;
        }
        &.vip_one_1 {
            .vip_one_empty {
                @apply bg-[#4D5BDF];
            }
            .vip_one_button {
                @apply bg-[#4D5BDF] text-[#fff] border-[#4D5BDF];
            }
            &:hover {
                @apply border-[#4C5BDF]; 
            }
            &.select {
                @apply max-sm:border-[#4C5BDF]; 
            }

        }
        &.vip_one_2 {
            .vip_one_empty {
                background: linear-gradient(90deg, #D19C6C 0%, #F6DDC0 50%, #DFAA7F 100%);
            }
            .vip_one_button {
                background: linear-gradient(90deg, #D19C6C 0%, #EAC69B 50%, #DFAA7F 100%);
                @apply text-[#fff] border-0;
            }
            &:hover {
                @apply border-[#DFCC7F]; 
            }
            &.select {
                @apply max-sm:border-[#DFCC7F]; 
            }
        }
        &.vip_one_3 {
            .vip_one_empty {
                background: linear-gradient(270deg, #3E3E3E 0%, #7E7E7E 50.68%, #131313 100%);
            }
            .vip_one_button {
                background: linear-gradient(270deg, #3A3A3A 0%, #626262 50.68%, #131313 100%);
                @apply text-[#fff] border-0;
            }
            &:hover {
                @apply border-[#181818]; 
            }
            &.select {
                @apply max-sm:border-[#181818]; 
            }
        }
        .vip_one_tag {
            @apply w-full flex flex-col items-center max-sm:border-t max-sm:border-t-[#C2C4CB] max-sm:pt-[20px];
        }
        .vip_one_ul {
            @apply text-[#333] text-base leading-[50px]   max-sm:text-[14px] max-sm:leading-[36px];
            img {
                @apply w-[9px] h-[6px] mr-[8px];
            }
        }
        &:hover {
            @apply sm:translate-y-[-20px] border border-[#24CCA7];
        }
        &:last-child{
            @apply mr-0;
        }
    }
}
</style>